import File from "../../types/files/File";
import { MockPromiseWrapper } from "./MockPromiseWrapper";

export enum FileExplorerTypes {
    Any = "all",
    Folders = "folders",
    Files = "files",
    Timetables = "TD",
    StudentOptions = "SO",
    DailyOrganisers = "DO"
}

export type FileExplorerType = FileExplorerTypes.Any | FileExplorerTypes.Folders | FileExplorerTypes.Files | FileExplorerTypes.Timetables | FileExplorerTypes.StudentOptions | FileExplorerTypes.DailyOrganisers;

interface FileExplorerEntry {
    type?: FileExplorerType,
    title?: string,
    denyUpload?: boolean,
    cancelReturn?: boolean,
    callback?: (selected: File, button?: string) => any,
    promise?: MockPromiseWrapper<FileExplorerResponse>,
}

export interface FileExplorerResponse {
    selected: File;
    button: string;
    response: boolean;
}

export default FileExplorerEntry;